import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@mui/material';

interface CaptionModalProps {
  open: boolean;
  initialCaption: string;
  onSave: (newCaption: string) => void;
  onClose: () => void;
}

const CaptionModal: React.FC<CaptionModalProps> = ({
                                                     open,
                                                     initialCaption,
                                                     onSave,
                                                     onClose,
                                                   }) => {
  const [caption, setCaption] = useState(initialCaption);

  useEffect(() => {
    if (open) {
      setCaption(initialCaption);
    }
  }, [open, initialCaption]);

  const handleSave = () => {
    onSave(caption.trim());
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Редактировать описание</DialogTitle>
      <DialogContent>
        <TextField
          sx={{mt: 3}}
          autoFocus
          multiline
          fullWidth
          variant="outlined"
          label="Описание"
          value={caption}
          onChange={(e) => setCaption(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Отмена</Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Сохранить
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CaptionModal;
